export const normalizeNavPath = (pathname) => {
  const path = String(pathname ?? "").split("?")[0];
  if (path.length > 1 && path.endsWith("/")) return path.slice(0, -1);
  return path || "/";
};

export const findNavLinkForPath = (pathname, links = []) => {
  const path = normalizeNavPath(pathname);
  let best = null;
  let bestLength = -1;

  for (const link of links) {
    if (!link?.link) continue;
    const candidate = normalizeNavPath(link.link);
    const matches = path === candidate || path.startsWith(`${candidate}/`);
    if (matches && candidate.length > bestLength) {
      best = link;
      bestLength = candidate.length;
    }
  }

  return best;
};
